// extracted by mini-css-extract-plugin
module.exports = {"container":"DonorProfile_container__1Gofs","contents":"DonorProfile_contents__1XiLr","title":"DonorProfile_title__27YUT"};